import BaseAtomView from 'views/atoms/base-atom-view';
import LocaleHeadingAtomTemplate from './templates/locale-heading-atom';

const LocaleHeadingAtom = BaseAtomView.extend({
  template: LocaleHeadingAtomTemplate,
  initialize: function () {
    BaseAtomView.prototype.initialize.apply(this, arguments);
  },
});

export default LocaleHeadingAtom;
